import React from 'react'
import { ManageJobs } from '../../../features/employerDashboard/components/ManageJobs'

const ManageJobsPage = () => {
  return (
    <div>
      <ManageJobs />
    </div>
  )
}

export default ManageJobsPage
